import { TextField } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import React, {useEffect, useState} from "react";

import { CheckCircle, CheckCircleOutlineSharp, Error } from "@mui/icons-material";

const AddSpaceRow = (props) => {
    let [name, setName] = useState()
    let [type, setType] = useState(props.space.brick_space_type)
    let [pnnlType, setPnnlType] = useState(props.space.pnnl_space_type)
    let [sqft, setSqft] = useState()
    let [height, setHeight] = useState(props.space.floor_to_ceiling_height)
    let [occupancy, setOccupancy] = useState()

    let [space, setSpace] = useState(props.space)

    let floor_id = props.space.floor_id;
    let spaceTypeOptions = props.spaceTypes;
    let pnnlSpaceTypeOptions = props.pnnlTypes;

    const updateForm = () => {
        let space = {
            name: name,
            brick_space_type: type,
            pnnl_space_type: pnnlType,
            area: parseFloat(sqft),
            floor_to_ceiling_height: parseFloat(height),
            volume: sqft && height ? parseFloat(sqft) * parseFloat(height) : 0,
            occupancy: occupancy,
            floor_id: floor_id,
        }
        props.callback(props.row_num, space)
    }

    useEffect(() => {
        updateForm();
    },[name, type, pnnlType, sqft, height, occupancy])

    let className = props.space.error ? "add-row row-toast" : "add-row" 
    
    return (
        <div className={className}>
            <div className="row-error">{props.space.error}</div>
            <div className="row-form-field">
                <TextField label="Name" variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}} required/>
            </div>
            <div className="row-form-field">
                <Autocomplete
                        disablePortal
                        id="spaceTypeOptions"
                        options={spaceTypeOptions}
                        getOptionLabel={option => option.name}
                        style={{ width: "200px" }}
                        defaultValue={spaceTypeOptions.find(o => o.brick_space_type === type)}
                        renderInput={(params) => <TextField {...params} label="Type" variant="outlined" size="small" required />}
                        groupBy={(option) => option.parent}
                        onChange={(event, newValue) => {
                            if (newValue) setType(newValue.brick_space_type) 
                        }}
                    />
            </div>
            <div className="row-form-field">
                <Autocomplete
                        disablePortal
                        id="pnnlSpaceTypeOptions"
                        width={250}
                        options={pnnlSpaceTypeOptions}
                        defaultValue={pnnlSpaceTypeOptions.find(o => o.name === pnnlType)}
                        getOptionLabel={option => option.name}
                        style={{ width: "200px" }}
                        renderInput={(params) => <TextField {...params} label="PNNL Classification" variant="outlined" size="small" />}
                        onChange={(event, newValue) => {
                            if (newValue) setPnnlType(newValue.name)
                        }}
                    />
            </div>
            <div className="row-form-field">
                <TextField label="Sq. Ft." variant="outlined" size="small" onChange={(e) => {setSqft(e.target.value)}}/>
            </div>
            <div className="row-form-field">
                <TextField label="Ceiling Height" variant="outlined" size="small" defaultValue={height || ""} onChange={(e) => {setHeight(e.target.value)}}/>
            </div>
            <div className="row-form-field">
                <TextField label="Occupancy" variant="outlined" size="small" onChange={(e) => {setOccupancy(e.target.value)}}/>
            </div>
            {
                props.space.success ?
                <div className="success-indicator">
                        <CheckCircle /> 
                </div> : props.space.success == false ?
                <div className="failure-indicator">
                        <Error /> 
                </div> : <div className="failure-indicator">

                </div>  
            }

        </div>
    )
}

export default AddSpaceRow;